module.exports = __webpack_public_path__ + "static/media/node.601628d0.webp";